
(function () {
  document.querySelectorAll('[data-z9-cats-slider]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-z9-cats-track]');
    var prevBtn = wrap.querySelector('[data-z9-cats-prev]');
    var nextBtn = wrap.querySelector('[data-z9-cats-next]');
    if (!track) return;

    var cards = track.children;
    var offset = 0;
    var cardWidth = 0;
    var gap = 16;
    var visible = 5;

    function calcDimensions() {
      if (!cards.length) return;
      var cardRect = cards[0].getBoundingClientRect();
      cardWidth = cardRect.width + gap;
      var wrapWidth = wrap.querySelector('[data-z9-cats-viewport]').offsetWidth;
      visible = Math.round(wrapWidth / cardWidth);
    }

    function maxOffset() {
      return Math.max(0, cards.length - visible);
    }

    function slide() {
      track.style.transform = 'translateX(' + (-offset * cardWidth) + 'px)';
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        calcDimensions();
        offset = Math.max(0, offset - 1);
        slide();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        calcDimensions();
        offset = Math.min(maxOffset(), offset + 1);
        slide();
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        calcDimensions();
        offset = Math.min(offset, maxOffset());
        slide();
      }, 150);
    });
  });
})();
